import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './download-button.module.css';

type Props = {
  readonly releaseId: number;
  readonly companyId: number;
  readonly onClickDownload?: () => void;
};

export function PressReleaseInformationDownloadButton({
  releaseId,
  companyId,
  onClickDownload,
}: Props) {
  return (
    <div
      className={clsx(
        styles.downloadButton,
        isContainerQueryAvailable()
          ? styles.downloadButtonPressReleaseRoot
          : styles.downloadButtonScreen,
      )}
    >
      <a
        download
        href={`/im/action.php?run=html&page=releaseimage&company_id=${companyId}&release_id=${releaseId}`}
        className={clsx(
          styles.button,
          isContainerQueryAvailable()
            ? styles.buttonPressReleaseRoot
            : styles.buttonScreen,
        )}
        onClick={onClickDownload}
      >
        <DownloadIcon className={styles.icon} />
        <span>プレスリリース素材</span>
      </a>
      <p>
        このプレスリリース内で使われている画像ファイルがダウンロードできます
      </p>
    </div>
  );
}

function DownloadIcon({...props}) {
  return (
    <svg
      aria-hidden='true'
      width='20'
      height='18'
      viewBox='0 0 20 18'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_3895_35412)'>
        <g>
          <g>
            <path
              d='M0 13V16C0 17.093 0.907 18 2 18H18C19.093 18 20 17.093 20 16V13H18V16H2V13H0ZM9 0V10.586L4.707 6.293L3.293 7.707L10 14.414L16.707 7.707L15.293 6.293L11 10.586V0H9Z'
              fill='black'
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_3895_35412'>
          <rect width='20' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
